import React from 'react';
import './travel-protection-details.css';

class TravelProtectionDetails extends React.Component {

    render = () => {
        const guests = this.props.guests;
        const insuranceParagraph = this.props.insuranceParagraph;

        const guestsBlock = guests.map((guest, index) => {
            return <tr>
                <th scope="row" className="text-center rea-guestCount">{index + 1}</th>
                { guest.middleName &&
                    <td className="rea-guestName">{guest.firstName} {guest.middleName} {guest.lastName}</td>
                }
                {  !guest.middleName &&
                    <td className="rea-guestName">{guest.firstName} {guest.lastName}</td>
                }
                <td className="text-center rea-guestTravelProtectionStatus">{(guest.travelProtectionUrl &&
                    <a href={guest.travelProtectionUrl}
                       target='_blank' rel="noopener noreferrer">{guest.travelProtectionStatus}</a>) || guest.travelProtectionStatus}</td>
            </tr>
        });
        //const booking = this.props.booking;
        //const attributes = this.props.attributes;
        return (
            <div className="travel-protection-details">
                <div className="rea-travelProtectionDetailsContainer rea-block-row">
                    <div className="rea-block-12">
                        <div className="rea-sectionHeaders">Travel Insurance Details</div>
                    </div>
                </div>
                <div className="rea-guestContainer rea-block-row">
                    <div className="rea-block-12">
                        <div className="rea-bold">
                            The first and last names on your ticket must match your identification.
                        </div>
                        <div>
                            Please review the names below, and contact us if there are any discrepancies.
                        </div>
                    </div>
                    <div className="rea-block-12 rea-guestTable">
                        <table className="table table-striped table-bordered">
                            <thead className="tableHeader">
                            <tr>
                                <th scope="col" className="text-center rea-guestCount">Guest</th>
                                <th scope="col">Guest Name</th>
                                <th scope="col" className="text-center rea-guestTravelProtectionStatus">Travel
                                    Insurance Status
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {guestsBlock}
                            </tbody>
                        </table>
                    </div>
                    <div className="rea-block-12">
                        <div>{insuranceParagraph}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TravelProtectionDetails;
